import { render, staticRenderFns } from "./BreakoutRoomItem.vue?vue&type=template&id=63234d26&scoped=true"
import script from "./BreakoutRoomItem.vue?vue&type=script&lang=js"
export * from "./BreakoutRoomItem.vue?vue&type=script&lang=js"
import style0 from "./BreakoutRoomItem.vue?vue&type=style&index=0&id=63234d26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63234d26",
  null
  
)

export default component.exports